import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('Bracketz Error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding:'40px', textAlign:'center', fontFamily:'sans-serif' }}>
          <div style={{ fontSize:'48px', marginBottom:'16px' }}>⚠️</div>
          <div style={{ fontSize:'20px', fontWeight:'700', marginBottom:'8px', color:'#fff' }}>Something went wrong</div>
          <div style={{ fontSize:'14px', color:'#aaa', marginBottom:'24px' }}>Don't worry — your picks are saved.</div>
          <button onClick={() => window.location.reload()} style={{ backgroundColor:'#F97316', color:'#fff', border:'none', borderRadius:'12px', padding:'12px 24px', fontSize:'14px', fontWeight:'700', cursor:'pointer' }}>
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
